import React, { Component } from "react";
import ExpandCommand from "../Commands/ExpandCommand/ExpandCommand";
import CollapseCommand from "../Commands/CollapseCommand/CollapseCommand";
import OpenCommand from "../Commands/OpenCommand/OpenCommand";
import ReduceCommand from "../Commands/ReduceCommand/ReduceCommand";
import CheckBox from "../Commands/CheckBox/CheckBox";
import "./TreeItem.css";

class TreeItem extends Component {
  
  render() {
    
    return (
      <div style={{ display: "flex" }}>
         { (this.props.withCheckBox || this.props.isMenuHasChilds ) &&
          <div onClick={this.props.onExpandCollapseClick}
              style={{visibility: this.props.isMenuHasChilds ? "visible" : "hidden",
              height: "25px",}}>
            <ExpandCommand isShow={!this.props.isExpanded} />
            <CollapseCommand isShow={this.props.isExpanded} isStandard={false} />
          </div>
        }
        { this.props.withCheckBox &&
          <CheckBox
            checked={this.props.isChecked}
            isLeastOneAndNotAllChildsChecked={
            this.props.isLeastOneAndNotAllChildsChecked
          }
          click={this.props.onCheckBoxClick}
        />
      }
        <div className="treeItem"  style={{ backgroundColor: this.props.backgroundColor }}>{this.props.item}</div>
        <div style={{ display: "flex", marginLeft: "auto" }}>
          <div onClick={this.props.showScrollTop ? this.props.onScrollTop : undefined} style={{ width: "20px" }}  >
            <ReduceCommand isShow={this.props.showScrollTop} isStandard={true} />
          </div>
          <div onClick={this.props.showScrollBottom ? this.props.onScrollBottom : undefined} style={{ width: "20px" }}>
            <CollapseCommand isShow={this.props.showScrollBottom} isStandard={true} />
          </div>
        </div>
      </div>
    );
  }
}

export default TreeItem;
